import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './style.css';

export default ToastContainer;
ToastContainer.defaultProps = {
  ...ToastContainer.defaultProps,
  position: 'bottom-right',
  autoClose: 7000,
  hideProgressBar: false,
  closeButton: false,
};
